import script from "./BalDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./BalDropdown.vue?vue&type=style&index=0&id=583fdd24&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-583fdd24"]])

export default __exports__